import { Centre } from '../../../types/centre'
import { SharedApolloClientBase, TypedApolloClientBase } from '../../types'
import { GetCentresQuery } from './query'

export const getCentres = async (
  client: SharedApolloClientBase,
  country: string
): Promise<Centre[]> => {
  const { data } = await (client as TypedApolloClientBase).query({
    query: GetCentresQuery,
    context: { version: 2 },
    variables: {
      country,
    },
  })
  if (!data?.cfCentreCollection?.items) {
    throw new Error('No data returned')
  }

  const centres = data.cfCentreCollection.items.map(item => {
    if (
      !item?.title ||
      !item.suburb ||
      !item.state ||
      !item.latitude ||
      !item.longitude ||
      !item.status ||
      !item.country ||
      !item.slug
    ) {
      throw new Error('Invalid data returned')
    }
    return {
      title: item?.title,
      physicalAddress: '',
      suburb: item?.suburb,
      state: item?.state,
      postcode: '',
      latitude: item?.latitude,
      longitude: item?.longitude,
      telephoneNumber: '',
      tradingHours: [],
      timeZone: '',
      emailAddress: '',
      features: [],
      sys: {
        id: 'unknown',
      },
      status: item?.status,
      country: item?.country,
      slug: item?.slug,
      facebook: '',
      twitter: '',
      instagram: '',
      jibestreamV4VenueId: 0,
      contactLinks: [],
      centreBanner: {
        hours: '',
        text: { description: '', isColored: false },
      },
    }
  })

  return centres
}
